module.exports = __webpack_public_path__ + "img/prompt-icon-1.67aeb8b7.png";